import { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { ratingsService, PendingRating } from '@/services/ratings';
import { useAuth } from './useAuth';

export function useMandatoryRating() {
  const [pendingRating, setPendingRating] = useState<PendingRating | null>(null);
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();
  const location = useLocation();

  const checkPendingRatings = useCallback(async () => {
    if (!user || user.role === 'ADMIN') return;

    // Não verifica se já estamos em rotas que não devem ser bloqueadas se possível
    // Mas o ideal é verificar sempre para garantir o bloqueio global
    
    setLoading(true);
    try {
      const response = await ratingsService.getPendingRatings();
      if (response.success && response.data && response.data.length > 0) {
        setPendingRating(response.data[0]);
      } else {
        setPendingRating(null);
      }
    } catch (error) {
      console.error('[useMandatoryRating] Erro ao buscar avaliações pendentes:', error);
    } finally {
      setLoading(false);
    }
  }, [user]);

  // Verifica ao mudar de rota ou quando o usuário loga
  useEffect(() => {
    checkPendingRatings();
  }, [location.pathname, user, checkPendingRatings]);

  return {
    pendingRating,
    loading,
    refresh: checkPendingRatings,
  };
}
